import { color, rem, radius, border } from '@thiememeulenhoff/lit-sdk/src';
import { NO_SCORE_TYPES, ScoreLevel } from '@thiememeulenhoff/types';
import { CSSResult, css, unsafeCSS } from 'lit';
import {
  SCORE_LEVEL_COLOR_HOVER_MAP,
  SCORE_LEVEL_COLOR_MAP,
  SCORE_LEVEL_TEXT_COLOR_MAP,
  SCORE_LEVEL_NEUTRAL_TEXT_COLOR_MAP,
} from './score-label.types';

const forScoreLevel = (
  level: ScoreLevel,
  levelColor: CSSResult,
  textColor: CSSResult,
  hoverColor: CSSResult,
  neutralTextColor: CSSResult,
) => css`
  :host([level='${unsafeCSS(level)}']) {
    background-color: ${levelColor};
    color: ${textColor};
  }

  :host([active][level='${unsafeCSS(level)}']) {
    background-color: ${color('white')};
    color: ${levelColor};
  }

  :host([active][level='${unsafeCSS(level)}']:hover) {
    background-color: ${color('white')};
    color: ${levelColor};
  }

  :host([level='${unsafeCSS(level)}']:hover) {
    background-color: ${hoverColor};
  }

  :host([neutral][level='${unsafeCSS(level)}']) {
    color: ${neutralTextColor};
  }
`;

const scoreLevelsCss = Object.keys(SCORE_LEVEL_COLOR_MAP).map((label) =>
  forScoreLevel(
    label as ScoreLevel,
    SCORE_LEVEL_COLOR_MAP[label as ScoreLevel],
    SCORE_LEVEL_TEXT_COLOR_MAP[label as ScoreLevel],
    SCORE_LEVEL_COLOR_HOVER_MAP[label as ScoreLevel],
    SCORE_LEVEL_NEUTRAL_TEXT_COLOR_MAP[label as ScoreLevel],
  ),
);

const noScoreTypesCss = NO_SCORE_TYPES.map(
  (scoreType) => css`
    :host([score-type='${unsafeCSS(scoreType)}'][level]) {
      background-color: ${color('green', 600)};
      color: ${color('white')};
    }
    :host([active][score-type='${unsafeCSS(scoreType)}'][level]) {
      background-color: ${color('white')};
      color: ${color('green', 600)};
    }
    :host([score-type='${unsafeCSS(scoreType)}'][level]:hover) {
      background-color: ${color('green', 700)};
    }
  `,
);

export const scoreLabelStyles = [
  ...scoreLevelsCss,
  css`
    :host {
      align-items: center;
      block-size: ${rem(32)};
      border-radius: ${radius('small')};
      box-sizing: border-box;
      display: inline-flex;
      justify-content: center;
      padding: ${rem(8, 16)};
    }


    :host([neutral]) {
      background-color: ${color('grey', 100)};
      border: ${border(1, 'teal', 600)};
      color: ${color('teal', 600)};
    }

    :host([neutral][level]:not([pill])) {
      background-color: ${color('teal', 600)};
      color: ${color('white')};
    }

    :host([pill]) {
      border-radius: ${radius('extra-large')};
    }

    :host([pill][neutral]),
    :host([pill][neutral][level]) {
      border: unset;
      background-color: ${color('grey', 100)};
      outline: ${rem(1)} solid ${color('grey', 300)};
      outline-offset: ${rem(-1)};
    }

    :host([pill][neutral]:not([level])) {
      color: ${color('grey', 300)};
    }

    :host([pill][neutral]:hover),
    :host([pill][neutral][level]:hover) {
      background-color: ${color('grey', 200)};
    }

    :host([pill][neutral]:not([level]):hover) {
      color: ${color('grey', 400)};
    }

    :where(.score-icon) {
      min-inline-size: ${rem(16)};
    }
  }
  `,
  ...noScoreTypesCss,
];
